import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ContactForm from '../ContactForm';
import data from "../../data/mainData.json";
import { FaLocationPin, FaMapLocationDot, FaUserCheck } from 'react-icons/fa6';
import { RiContactsBook3Fill } from 'react-icons/ri';
import Social from './social';

class ContactInfo extends Component {
	render() {

		let publicUrl = process.env.PUBLIC_URL + '/'

		return <div className="ltn__contact-address-area">
			<div className="container mt-5 mb-5">
				{/* <div className="row ">
					<div className="col-lg-5 h-100">
						<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
							<div className="ltn__contact-address-icon">
								<img src={publicUrl + "assets/img/icons/10.png"} alt="Icon Image" />
							</div>
							<h3>Email Address</h3>
							<p>{data?.contact?.email}<br /> <br /></p>
						</div>
						<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
							<div className="ltn__contact-address-icon">
								<img src={publicUrl + "assets/img/icons/11.png"} alt="Icon Image" />
							</div>
							<h3>Phone Number</h3>
							<p>{data?.contact?.phone_1}<br />
								{data?.contact?.phone_2}
							</p>
						</div>
						<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/12.png"} alt="Icon Image" />
						</div>
						<h3>Office Address</h3>
						<p>MR complex, Marakadai Bus Stop, College road, Tirupur</p>
					</div>
					<ContactForm />
					</div>
					
					<div className="col-lg-7 h-100">
						<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/10.png"} alt="Icon Image" />
						</div>
						<h3>Email Address</h3>
						<p>cheranproperties@gmail.com <br /> <br /></p>
					</div>
						<div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
						<div className="ltn__contact-address-icon">
						<img src={publicUrl+"assets/img/icons/11.png"} alt="Icon Image" />
						</div>
						<h3>Phone Number</h3>
						<p>+91 9629244450 <br />
						+91 8870744450
						</p>
					</div>
						<div className="box-shadow">
  <div className="p-5 h-100">
    <div className="d-flex mb-4">
      <div className="me-3">
        <FaMapLocationDot size={40} style={{ color: "#2DBB62"}} />
      </div>
      <div>
        <h3 className="mb-1">Office Address</h3>
        <p className="mb-0">{data?.contact?.address_1}</p>
        <p className="mb-0">{data?.contact?.address_2}</p>
      </div>
    </div>

   
    <div className="d-flex mb-4">
      <div className="me-3">
        <RiContactsBook3Fill size={40} style={{ color: "#2DBB62"}} />
      </div>
      <div>
        <h3 className="mb-1">Contact Details</h3>
        <p className="mb-0">{data?.contact?.phone_1}</p>
        <p className="mb-0">{data?.contact?.phone_2}</p>
        <p className="mb-0">{data?.contact?.email}</p>
      </div>
    </div>

    
    <div className="d-flex">
      <div className="me-3">
        <FaUserCheck size={40} style={{ color: "#2DBB62"}}/>
      </div>
      <div>
        <h3 className="mb-2">Follow Us On</h3>
        <Social />
      </div>
    </div>

  </div>
</div>

						
					</div>
				</div> */}

				<div className="row d-flex align-items-stretch">

  {/* Left Column */}
  <div className="col-lg-5 h-100">
    <div className="box-shadow h-100">
      <ContactForm />
    </div>
  </div>

  {/* Right Column */}
  <div className="col-lg-7 ">
    <div className="box-shadow h-100">
      <div className="p-5 h-100">

        {/* Office Address */}
        <div className="d-flex mb-4">
          <div className="me-3">
            <FaMapLocationDot size={40} style={{ color: "#2DBB62" }} />
          </div>
          <div>
            <h3 className="mb-1">Office Address</h3>
            <p className="mb-0">{data?.contact?.address_1}</p>
            <p className="mb-0">{data?.contact?.address_2}</p>
          </div>
        </div>

        {/* Contact Details */}
        <div className="d-flex mb-4">
          <div className="me-3">
            <RiContactsBook3Fill size={40} style={{ color: "#2DBB62" }} />
          </div>
          <div>
            <h3 className="mb-1">Contact Details</h3>
            <p className="mb-0">{data?.contact?.phone_1}</p>
            <p className="mb-0">{data?.contact?.phone_2}</p>
            <p className="mb-0">{data?.contact?.email}</p>
          </div>
        </div>

        {/* Follow Us */}
        <div className="d-flex">
          <div className="me-3">
            <FaUserCheck size={40} style={{ color: "#2DBB62" }} />
          </div>
          <div>
            <h3 className="mb-2">Follow Us On</h3>
            <Social />
          </div>
        </div>

      </div>
    </div>
  </div>

</div>



			</div>
		</div>
	}
}

export default ContactInfo